import type { WFaqTranslations } from "./pl";

export const de: WFaqTranslations = {
  defaultTitle: "Häufig gestellte Fragen",
};
